import { render, staticRenderFns } from "./ZipcodeStructure.vue?vue&type=template&id=1ffd4447&"
import script from "./ZipcodeStructure.vue?vue&type=script&lang=ts&"
export * from "./ZipcodeStructure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports